import React, { PropsWithChildren, createContext } from "react"
import { useGoogleMapInstance } from "../../shared/hooks/useGoogleMapInstance/useGoogleMapInstance"

export type GoogleMapInstanceProviderContext = {
  isLoaded: boolean
  loadError: Error | undefined
}

const GoogleMapInstanceContext =
  createContext<GoogleMapInstanceProviderContext>({
    isLoaded: false,
    loadError: undefined,
  })

const GoogleMapInstanceProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const { isLoaded, loadError } = useGoogleMapInstance()

  return (
    <GoogleMapInstanceContext.Provider value={{ isLoaded, loadError }}>
      {children}
    </GoogleMapInstanceContext.Provider>
  )
}

export { GoogleMapInstanceProvider, GoogleMapInstanceContext }
